import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ButtonComponent } from 'ngx-mat-esign360';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-button-file-input',
  templateUrl: './button-file-input.component.html',
  styleUrls: ['./button-file-input.component.scss'],
})
export class ButtonFileInputComponent implements OnInit, AfterContentInit {
  @ContentChild(ButtonComponent, { read: ElementRef }) buttonRef: ElementRef;
  @ViewChild('fileInput') fileInputRef: ElementRef;
  @Output() fileChange = new EventEmitter<FileList>();

  constructor() {}

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    fromEvent(this.buttonRef.nativeElement, 'click').subscribe(() => {
      this.fileInputRef.nativeElement.click();
    });
  }

  onFileSelect(files: FileList): void {
    this.fileChange.emit(files);
    (this.fileInputRef.nativeElement as HTMLInputElement).value = null;
  }
}
